export enum MOBILE_GENERAL_SETTINGS {
    /**
     * @value Display communities from
     */
    MOBILE_COMMUNITY_INSTANCES_SELECT = 'ADMIN.MOBILE_COMMUNITY_INSTANCES_SELECT',
    /**
     * @value The mobile application displays communities from the selected sites. If no site is selected, the platform default site is used as a fallback.
     */
    MOBILE_COMMUNITY_INSTANCES_SELECT_HELPER = 'ADMIN.MOBILE_COMMUNITY_INSTANCES_SELECT_HELPER',
    /**
     * @value Display search results from
     */
    MOBILE_SEARCH_INSTANCES_SELECT = 'ADMIN.MOBILE_SEARCH_INSTANCES_SELECT',
    /**
     * @value Select which sites are accessible through the mobile application search. If no site is selected, the sites chosen for communities on mobile are used.
     * If no site is selected for communities, the mobile application searches all sites on the platform and provides filtering by site.
     */
    MOBILE_SEARCH_INSTANCES_SELECT_HELPER = 'ADMIN.MOBILE_SEARCH_INSTANCES_SELECT_HELPER',
    /**
     * @value General settings
     */
    TITLE = 'ADMIN.NAV.MOBILE_GENERAL_SETTINGS',
}
